import { requestApiJson } from './client';

const getJson = async (path) => {
  const { data } = await requestApiJson(path);
  return data || {};
};

const filenameFromDisposition = (disposition) => {
  const s = String(disposition || '');
  const star = s.match(/filename\*=UTF-8''([^;]+)/i);
  if (star) {
    try { return decodeURIComponent(star[1]); } catch { /* noop */ }
  }
  const plain = s.match(/filename="([^"]+)"/i);
  return plain ? plain[1] : 'chat-media.zip';
};

const postZipDownload = async (path, { imageIds = [], fileIds = [] } = {}) => {
  const { data, response: res } = await requestApiJson(path, {
    method: 'POST',
    body: { imageIds, fileIds },
  });
  if (!res.ok) {
    throw new Error(data?.message || 'ダウンロードに失敗しました。');
  }
  const blob = await res.blob();
  const filename = filenameFromDisposition(res.headers.get('Content-Disposition'));
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// base（例: /event-chat/events/xxx）に対する loadLinks/loadMedia/downloadZip を束ねる。
const makeSource = (base) => ({
  loadLinks: (offset, limit) => getJson(`${base}/links/${offset}/${limit}`),
  loadMedia: (offset, limit) => getJson(`${base}/media/${offset}/${limit}`),
  downloadZip: (selection) => postZipDownload(`${base}/media/download-zip`, selection),
});

export const eventChatAssetSource = (eventId) => makeSource(`/event-chat/events/${encodeURIComponent(eventId)}`);
export const adminPersonalChatAssetSource = (artistId) => makeSource(`/admin/messages/${encodeURIComponent(artistId)}`);
export const artistPersonalChatAssetSource = () => makeSource('/artist/messages');
export const adminGroupChatAssetSource = (threadId) => makeSource(`/admin/group-chat/threads/${encodeURIComponent(threadId)}`);
export const artistGroupChatAssetSource = (threadId) => makeSource(`/artist/group-chat/threads/${encodeURIComponent(threadId)}`);
